import { css } from 'styled-components';

import { breakpoints, styled } from '@notino/react-styleguide';

export const Wrapper = styled.div<{ newDesign: boolean }>`
  ${({ newDesign }) =>
    newDesign
      ? css`
          margin-top: 1.5rem;
          @media (min-width: ${breakpoints.lg}) {
            margin-bottom: 4rem;
          }
        `
      : css`
          margin-top: 2rem;
        `};
`;
